// extracted by mini-css-extract-plugin
module.exports = {"halo":"SafeLogoHalo_halo__G0UJD","logoDarkFill":"SafeLogoHalo_logoDarkFill__d6WSa"};